import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-policies',
  templateUrl: './policies.component.html',
  styleUrls: ['./policies.component.css']
})
export class PoliciesComponent implements OnInit {
  public clgType: String;
  constructor(private router: Router) { }

  ngOnInit() {
    this.clgType = sessionStorage.getItem('clgtype');
  }
 Register(){
  this.router.navigate(['/studentreg']);

 }

 getYear(){
  return (new Date().getFullYear()+(new Date().getMonth()<=3?0:1));
 }
}
